import React, {Component} from 'react';
import {Router} from 'react-router-dom';
import {connect} from 'react-redux';
import history from 'config/history';

import routes from 'config/routes.js';

import routeUtils from 'util/routeUtils';

import 'style/app.scss';

class App extends Component {
    render() {
        const {state} = this.props;

        return (
            <Router history={history}>
                {routeUtils.createSwitch(routes, state)}
            </Router>
        );
    }
}

const mapStateToProps = state => ({state});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.jsx